export default class LedgerAccountApiModel {
  constructor(rawModel) {
    this.Key = rawModel?.Key || null
    this.BusinessUnitKey = rawModel?.BusinessUnitKey || null
    this.BusinessUnit = rawModel?.BusinessUnit || null // string
    this.Name = rawModel?.Name || null
    this.Number = rawModel?.Number || null
    this.Active = rawModel?.Active || null
    this.CostCenters = rawModel?.CostCenters?.map(x => new CostCenterApiModel(x)) || []
    this.DiscountLedgerAccounts =
      rawModel?.DiscountLedgerAccounts?.map(x => new DiscountLedgerAccountApiModel(x)) || []
  }
}

class CostCenterApiModel {
  constructor(rawModel) {
    this.Key = rawModel?.Key
    this.Name = rawModel?.Name
    this.Code = rawModel?.Code
    this.Active = rawModel?.Active
  }
}

class DiscountLedgerAccountApiModel {
  constructor(rawModel) {
    this.Key = rawModel?.Key
    this.Name = rawModel?.Name
    this.Number = rawModel?.Number
    this.Active = rawModel?.Active
  }
}
